import React, { useState } from "react";
import {
  Navbar,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Container,
  Row,
  Col,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
} from "reactstrap";
import { useLocation, Link, useNavigate } from "react-router-dom";
import { handleLogout } from "../../redux/authentication";
import { useDispatch, useSelector } from "react-redux";
import LoginModal from "../Auth/LoginModal";

const Layout = ({ children, setUserRights }) => {
  const location = useLocation();
  const path = location.pathname;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.authentication);
  const [loginModalOpen, setLoginModalOpen] = useState(false);

  const toggleLoginModal = () => {
    setLoginModalOpen(!loginModalOpen);
  };

  const logoutHandler = () => {
    dispatch(handleLogout());
    sessionStorage.clear();
    localStorage.clear();
    navigate("/", { replace: true });
  };

  return (
    <div className="retail-layout-wrapper">
      {/* Modern Main Navigation Header */}
      <Navbar expand="lg" className="retail-navbar sticky-top px-3 px-md-4">
        <Container fluid>
          <NavbarBrand tag={Link} to="/" className="d-flex align-items-center gap-2">
            <div className="brand-icon-box">
              <i className="bi bi-shop"></i>
            </div>
           
          </NavbarBrand>

          <Nav className="ms-auto d-flex align-items-center gap-2" navbar>
            {(path === "/" || path === "/store-partner-signup") ? (
              <NavItem>
              
              </NavItem>
            ) : path === "/about" ? (
              <>
                <NavItem>
                  <NavLink tag={Link} to="/about" className="nav-link-retail">
                    About
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink tag={Link} to="/about-team" className="nav-link-retail">
                    Our Team
                  </NavLink>
                </NavItem>
              </>
            ) : (
              <>
                {/* Operations Dropdown */}
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav caret className="nav-link-retail">
                    <i className="bi bi-grid-3x3-gap me-1"></i> Operations
                  </DropdownToggle>
                  <DropdownMenu end className="retail-dropdown-menu">
                    <div className="dropdown-header-text">Recruitment & Staffing</div>
                    <DropdownItem onClick={() => navigate("/job-posts")}>
                      <i className="bi bi-bag-check me-2"></i> Categories Cart
                    </DropdownItem>
                    <DropdownItem onClick={() => navigate("/candidate_form")}>
                      <i className="bi bi-file-earmark-person me-2"></i> Recruitment Form
                    </DropdownItem>
                    <DropdownItem onClick={() => navigate("/candidate_list")}>
                      <i className="bi bi-people me-2"></i> Candidate List
                    </DropdownItem>
                    <DropdownItem divider />
                    <div className="dropdown-header-text">Compliance</div>
                    <DropdownItem><i className="bi bi-shield-check me-2"></i> Statutory Compliance</DropdownItem>
                    <DropdownItem><i className="bi bi-bar-chart-line me-2"></i> Reporting & Analytics</DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>

                {/* Employees Info Dropdown */}
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav caret className="nav-link-retail">
                    <i className="bi bi-person-badge me-1"></i> Employees Info
                  </DropdownToggle>
                  <DropdownMenu end className="retail-dropdown-menu">
                    <DropdownItem onClick={() => navigate("/dashboard")}>
                      <i className="bi bi-speedometer2 me-2"></i> Dashboard
                    </DropdownItem>
                    <DropdownItem onClick={() => navigate("/attendance")}>
                      <i className="bi bi-calendar-check me-2"></i> Attendance
                    </DropdownItem>
                    <DropdownItem onClick={() => navigate("/emp-management")}>
                      <i className="bi bi-person-gear me-2"></i> Employee Management
                    </DropdownItem>
                    <DropdownItem onClick={() => navigate("/leave-management")}>
                      <i className="bi bi-calendar-minus me-2"></i> Leave Management
                    </DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem><i className="bi bi-graph-up-arrow me-2"></i> Performance & Appraisal</DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>

                {/* Accounts Dropdown */}
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav caret className="nav-link-retail">
                    <i className="bi bi-wallet2 me-1"></i> Accounts
                  </DropdownToggle>
                  <DropdownMenu end className="retail-dropdown-menu">
                    <DropdownItem onClick={() => navigate("/payroll")}>
                      <i className="bi bi-cash-stack me-2"></i> Payroll Processing
                    </DropdownItem>
                    <DropdownItem onClick={() => navigate("/payslip")}>
                      <i className="bi bi-receipt me-2"></i> Pay Slip
                    </DropdownItem>
                    <DropdownItem onClick={() => navigate("/leavemanagement")}>
                      <i className="bi bi-gift me-2"></i> Benefits & Reimbursements
                    </DropdownItem>
                    <DropdownItem onClick={() => navigate("/leavemanagement")}>
                      <i className="bi bi-bank me-2"></i> Loan & Advance Management
                    </DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem onClick={() => navigate("/leavemanagement")}>
                      <i className="bi bi-calculator me-2"></i> Tax Management & Deductions
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>

                {/* User Profile Capsule */}
                {auth?.userData?.user && (
                  <div className="user-profile-capsule ms-2">
                    <span className="user-avatar-small">
                      {auth.userData.user.charAt(0).toUpperCase()}
                    </span>
                    <span className="user-name-text">{auth.userData.user}</span>
                  </div>
                )}

                {/* Logout Button */}
                <NavItem className="ms-2">
                  <button className="btn-retail-outline-danger" onClick={logoutHandler}>
                    <i className="bi bi-box-arrow-right"></i>
                  </button>
                </NavItem>
              </>
            )}
          </Nav>
        </Container>
      </Navbar>

      {/* Dynamic Action Container (Floating Dashboard Widget) */}
      <div className="icon-container" title="Quick Actions">
        <div className="icon-wrapper" data-tooltip="Store Inventory">
          <span className="tree-icon">
            <i className="bi bi-tree-fill"></i>
          </span>
          <span className="village-badge">3</span>
        </div>
        <div className="icon-wrapper" data-tooltip="Floor Layout">
          <span className="chair-icon">
            <i className="bi bi-shop-window"></i>
          </span>
        </div>
      </div>

      {/* Render Page Children */}
      <main className="main-content-area">{children}</main>

      {/* Modernized Retail Footer */}
      <footer className="naadan-footer mt-5">
        <Container>
          <Row className="gy-4 text-center text-md-start align-items-start">
            <Col lg="4" md="6">
              <div className="d-flex align-items-center gap-2 mb-3">
                <div className="brand-icon-box small">
                  <i className="bi bi-shop"></i>
                </div>
                <h5 className="fw-bold naadan-header m-0">Naadan Mart</h5>
              </div>
              <p className="footer-description">
                A modern retail experience built with local partners, redefining
                the way communities shop, connect, and thrive together.
              </p>
            </Col>

            <Col lg="4" md="6">
              <h6 className="footer-heading">Contact Support</h6>
              <ul className="list-unstyled footer-contact-list">
                <li>
                  <i className="bi bi-envelope text-accent"></i>
                  <a href="mailto:info@paupetsoft.com">info@paupetsoft.com</a>
                </li>
                <li>
                  <i className="bi bi-telephone text-accent"></i>
                  <a href="tel:+919886433255">+91 9886433255</a>
                </li>
              </ul>
            </Col>

            <Col lg="4" md="12">
              <h6 className="footer-heading">Headquarters</h6>
              <address className="footer-address">
                <i className="bi bi-geo-alt me-2 text-accent"></i>
                #77 Olive Tree, 2nd Floor, 1st Main Road, Somashekar Reddy Layout,
                Margondanahalli, Bengaluru, Karnataka – 560036, India
              </address>
            </Col>
          </Row>

          <hr className="footer-divider my-4" />

          <Row className="align-items-center">
            <Col md="6" className="text-center text-md-start">
              <p className="copyright-text m-0">
                © {new Date().getFullYear()} <strong>PAUPET SOFT</strong>. All rights reserved.
              </p>
            </Col>
            <Col md="6" className="text-center text-md-end mt-2 mt-md-0">
              <span className="small text-muted">Powered by Naadan Retail Suite v2.4</span>
            </Col>
          </Row>
        </Container>
      </footer>

      {/* Login Modal */}
      <LoginModal
        isOpen={loginModalOpen}
        toggle={toggleLoginModal}
        setUserRights={setUserRights}
      />
    </div>
  );
};

export default Layout;